import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
// import { roleColumns } from './_columns'
import { roleColumns } from './_columnsC'
import { useAuth } from '../../../../auth'
import { useState } from 'react'

const mockedData = [
  {
    gender: 'Male',
    email: 'ashok@gmail.com',
    fullAddress: 'New Baneshwor, Kathmandu',
    mobile: '9860105561',
    joinDate: '2023/09/05',
    currentLevel: 'Manager',
    pointEarned: 45,
    pointRedeemed: 5,
    name: 'Ashok Karki',
    birthday: '1992/12/22',
  },
  {
    gender: 'Femal',
    email: 'aleshika@gmail.com',
    fullAddress: 'Old Baneshwor, Kathmandu',
    mobile: '9860105560',
    joinDate: '2023/09/06',
    currentLevel: 'Employee',
    pointEarned: 5,
    pointRedeemed: 15,
    name: 'Aleshki Chheri',
    birthday: '1996/06/06',
  },
]

const SearchIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    style={{
      position: 'absolute',
      left: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#6B7280',
    }}
  >
    <circle cx='11' cy='11' r='8' />
    <line x1='21' y1='21' x2='16.65' y2='16.65' />
  </svg>
)

const UserManagementList = () => {

  const [searchQuery, setSearchQuery] = useState('')
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }
  const { isFranchise, isPartner, isSupplyChainManager, currentUser } = useAuth()
  return (
    <KTCard>
      {/* <div
        style={{
          position: 'relative',
          width: '300px',
          marginLeft: '30px',
          marginBottom: '-30px',
        }}
      >
        <SearchIcon />
        <input
          type='text'
          placeholder='Search users...'
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: '100%',
            height: '40px',
            padding: '8px 8px 8px 35px',
            fontSize: '14px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: 'white',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
          onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
        />
      </div>
      {!isPartner && <UsersListHeader label='Add new' />} */}

      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 30px"
      }}>
        <div
          style={{
            position: 'relative',
            width: '300px',
          }}
        >
          <SearchIcon />
          <input
            type='text'
            placeholder='Search users...'
            value={searchQuery}
            onChange={handleSearch}
            style={{
              width: '100%',
              height: '40px',
              padding: '8px 8px 8px 35px',
              fontSize: '14px',
              border: '1px solid #E5E7EB',
              borderRadius: '6px',
              outline: 'none',
              backgroundColor: 'white',
              transition: 'border-color 0.2s ease',
            }}
            onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
            onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
          />
        </div>
        <div>
          {/* {!isPartner && <UsersListHeader label='Add new' />} */}
          {!isPartner && (currentUser as any)?.userType !== 'PICKUP_POINT_STAFF' && <UsersListHeader label='Add new' />}
        </div>
      </div>


      <UsersTable columnProps={roleColumns(isFranchise, isSupplyChainManager)} />

      <UserEditModal formName='FacilitiesModalFormCustomer' />
    </KTCard>
  )
}

const UserManagementWrapperC = () => (
  // <QueryRequestProvider initialValue={{ type: 'CUSTOMER', status: 'ACTIVE' }}>
  <QueryRequestProvider initialValue={{ type: 'PICKUP_POINT', facilityType: 'CONVERTER' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UserManagementList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { UserManagementWrapperC }
